export const getWorkspaceUrl = (organizationId: string) => {
  const root = window._acctConfig?.WORKSPACE_URL;
  return `${root}/${organizationId}`;
};

export const openWorkspace = (organizationId: string) => {
  const url = getWorkspaceUrl(organizationId);

  window.open(url, "_blank");
};
